<template>
  <div class="chapter-select">
    <select
      id="chapter-select"
      :name="name"
      class="elastic"
      v-model="selectedChapter"
    >
      <option
        v-for="(item, index) in items"
        :value="item.id"
        :key="item.id"
      >{{ 'MONS '+(items.length - index)+': '+item.chapterTranslations[0].title }}</option>
    </select>
    <i
      class="fa fa-caret-down"
      aria-hidden="true"
      v-on:click="openSelect"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'chapter-select',
  props: {
    name: String,
    items: Array,
    language: String
  },
  data: function () {
    return {
      selectedChapter: undefined
    }
  },
  methods: {
    openSelect: function () {
      var e = document.createEvent('MouseEvents')
      e.initMouseEvent('mousedown')
      document.getElementById('chapter-select').dispatchEvent(e)
    }
  },
  watch: {
    items: function () {
      this.selectedChapter = this.items[0].id
    },
    selectedChapter: function () {
      this.$parent.$emit('chapterChanged', this.selectedChapter)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.chapter-select {
  // overflow: hidden;
}

.bg-primary {
  select {
    background: darken($primary-color, 5%)
      url("/static/images/icon-arrow-down-white.png") no-repeat right;
  }
}

select {
  max-width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background: #fff url("/static/images/icon-arrow-down.png") no-repeat right;
  background-position-x: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  border: none;
  border-radius: 0;
  text-transform: uppercase;
  font-size: 0.75rem;
  font-weight: $bold;
  padding: 0 1.5rem 0 0;
  margin: 0;
  color: $txt-color-primary;

  &:focus {
    outline: none;
  }

  option {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

i {
  display: none;
  @media (max-width: $device-md) {
    // display: none;
  }
}
</style>



// WEBPACK FOOTER //
// ChapterSelect.vue?6c62bbb9